// src/shadowGrove/world/world.js
import { LIBERI_TERMS } from "./terminology";
import { LIBERI_GENIUS } from "./genius";
import { LIBERI_LOCATIONS } from "./locations";
export const LIBERI_WORLD = {
    realmName: "Liberi Curiosi",

    origin: {
        portal: "The Portal",
        forest: "The Sylvan Wilds",
        spark: "The First Spark",
        academy: "The Academy",
    },

    genius: {
        ...LIBERI_GENIUS,
        singular: "Genius",
        plural: "Genii",
    },

    locations: {
        ...LIBERI_LOCATIONS,
        dashboard: {
            name: "Atrium",
            description: "The central home view for daily guidance.",
        },
        archive: {
            name: "Codex",
            description: "The archive of records and progress.",
        },
    },

    terminology: LIBERI_TERMS,

    philosophy: {
        core: "The magic is already within the child. Curiosity awakens it. Learning strengthens it. The Genius reveals it.",
    },
};